import React from 'react';

import { useAssetBalance } from '../hooks/useAssetBalance';
import { useWithdrawHandler } from '../hooks/useWithdrawHandler';

import { AssetWithIcon, Button, ButtonSize, ButtonVariant } from '@/shared/ui';

export type AssetToClaimProps = {
    assetName: string;
};

export const AssetToClaimRow = ({ assetName }: AssetToClaimProps) => {
    const { balance, address, decimals } = useAssetBalance(assetName);
    const onWithdrawHandler = useWithdrawHandler(assetName, balance, address, decimals);

    return balance > 0 ? (
        <tr className='h-[72px] border-t border-opaque bg-primary hover:bg-background-secondary'>
            <td className='pl-6'>
                <AssetWithIcon assetName={assetName} />
            </td>
            <td>
                <div className='pl-6'>
                    <div>{balance.toString()}</div>
                </div>
            </td>
            <td>
                <div className='flex justify-end gap-5 mr-6'>
                    <Button
                        variant={ButtonVariant.Primary}
                        size={ButtonSize.Medium}
                        className='w-[100px]'
                        onClick={onWithdrawHandler}
                        disabled={false}
                    >
                        Withdraw
                    </Button>
                </div>
            </td>
        </tr>
    ) : null;
};
